<template>
    <div>
        <div class="centerTitle">仓储费计算</div>
        <el-form ref="form" :inline="false" size="mini" style="margin: 0 auto; width: 500px;" label-width="150px">
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr_normal"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>

                <el-button type="primary" @click="batchCalculation" size="mini" style="margin-left: 120px;">批量计算
                </el-button>

            </el-form-item>
            <el-form-item label="ASIN:" class="query-form-item">
                <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入ASIN"></el-input>
            </el-form-item>
            <el-form-item label="体积(立方英寸):">
                <el-input-number style="width: 150px;" clearable v-model="query.volume" placeholder="体积(立方英寸)"
                                 :min="0" :step="0.0001" size="mini"></el-input-number>
            </el-form-item>

            <el-form-item label="数量">
                <el-input-number style="width: 150px;" clearable v-model="query.number" placeholder="数量"
                                 :min="0" :step="1" size="mini"></el-input-number>
            </el-form-item>
            <el-form-item label="已存储天数">
                <el-input-number style="width: 150px;" clearable v-model="query.has_storage_days"
                                 placeholder="已存储天数"
                                 :min="0" :step="1" size="mini"></el-input-number>
            </el-form-item>

            <el-form-item label="存储至日期:">
                <el-date-picker style="width: 150px;" v-model="query.storage_until_date" type="date"
                                placeholder="存储至日期" size="mini" value-format="yyyy-MM-dd"/>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="onClean" size="mini">清空</el-button>
                <el-button type="primary" @click="singleComputation" size="mini" :loading="loading">计算</el-button>
            </el-form-item>
            <el-form-item label="单仓储费">
                <el-input-number style="width: 150px;" clearable v-model="query.single_charge" placeholder="单仓储费"
                                 :min="0" :step="0.0001" size="mini"></el-input-number>
            </el-form-item>
            <el-form-item label="总仓储费">
                <el-input-number style="width: 150px;" clearable v-model="query.all_charge" placeholder="总仓储费"
                                 :min="0" :step="0.0001" size="mini"></el-input-number>
            </el-form-item>
        </el-form>
        <addSubLibrary :visible="addSubLibraryModal" @close-callback="closeCllback"/>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import addSubLibrary from './/addSubLibrary.vue'

export default {
    components: {addSubLibrary},
    data() {
        return {
            query: {
                state: 'us',
                asin: '',
                volume: '',
                number: 0,
                single_charge: 0,
                all_charge: 0,
                has_storage_days: 0,
                storage_until_date: null,
            },
            addSubLibraryModal: false,
            loading:false,
        }
    },
    mounted() {
    },
    methods: {
        // 关闭弹窗回调
        closeCllback() {
            this.addSubLibraryModal = false
        },
        // 批量计算
        batchCalculation() {
            this.addSubLibraryModal = true
        },
        // 单个计算
        singleComputation() {
            this.loading = true
            api.extra_delivery_charge_calculator_calculate({...this.query}).then(res => {
                if (res.code === 0) {
                    const resData = res.data || {}
                    this.query.all_charge = resData.all_charge || 0
                    this.query.single_charge = resData.single_charge || 0
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 清空
        onClean() {
            this.query = {
                state: 'us',
                asin: '',
                volume: '',
                number: 0,
                single_charge: 0,
                all_charge: 0,
                has_storage_days: 0,
                storage_until_date: null,
            }
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.centerTitle {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}
.redTxt {
    color: red;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
